import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton'
import Form from 'react-bootstrap/Form';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MDBFile } from 'mdb-react-ui-kit';
import { toast } from 'react-toastify';
import axiosinterce from '../function/axiosInterceptor'
import React, { useState, useEffect, useRef } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import Moment from 'react-moment';
import 'moment-timezone';
const Banner = () => {
    const [menulist, setMenu] = useState([]);
    const [lgShow, setLgShow] = useState(false);
    const [banners, setUsers] = useState([]);

    const fatchBanner = async () => {
        try {
            const response = await axiosinterce.get('/admin/banners')
            if (response.status === 1) { setUsers(response.data); }
        } catch (err) {

        }

    }
    const fatchMenus = async () => {
        try {
            const response = await axiosinterce.get('/admin/menu-list')
            if (response.status === 1) { setMenu(response.data);; }
        } catch (err) {

        }

    }
    const Delete_bnr = async (id) => {
        try {
            const response = await axiosinterce.get(`/admin/delete_baner?sno=${id}`)
            if (response.status === 1) {
                toast.success(response.message, { autoClose: 700, position: 'top-center' })
                fatchBanner();
            } else {
                toast.warn(response.message, { autoClose: 700, position: 'top-center' })
            }
        } catch (err) {

        }

    }
    useEffect(() => { fatchBanner(); fatchMenus() }, [])
    const [content, setcontent] = useState([]);
    const AddBanner = async (b) => {
        b.preventDefault();
        var img = b.currentTarget.bannerimg.files;
        const formData = new FormData();
        formData.append('image', img[0]);
        formData.append('Pagetitle', b.currentTarget.page.value);
        formData.append('Heading', b.currentTarget.head.value);
        formData.append('Contant', content);
        formData.append('status', b.currentTarget.status.value);
        const response = await axiosinterce.post(`/admin/add-banner`, formData)
        if (response.status === 1) {
             setLgShow(false)
            toast.success(response.message, { autoClose: 700, position: 'top-center' })
            fatchBanner();
        } else {
            toast.warn(response.message, { autoClose: 700, position: 'top-center' })
        }
    }
    return (<>
        <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
                <div className="card" id="bdy">
                    <div className="card-body">
                        <div className='d-flex justify-content-between'>
                            <div className=''>
                                <h6 className="card-title">banner</h6>
                                <p className="text-muted mb-3">Total Banner :<code>{banners.length < 10 ? '0' + banners.length : banners.length}</code></p>
                            </div>
                            <div>
                                <button onClick={() => setLgShow(true)} className='custom-btn'><AiOutlinePlus /> Add New</button>
                            </div>
                        </div>
                        <div className="table-responsive pt-3">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Images</th>
                                        <th>Pges</th>
                                        <th>Status</th>
                                        <th>Last modify</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        banners.map((bnr) => {
                                            return (<>
                                                <tr>
                                                    <td><img src={process.env.REACT_APP_IMG_BASE_URL + "/img/" + bnr.image} className="baneimg" /></td>
                                                    <td>{bnr.page}</td>
                                                    <td>{bnr.status == 1 ? <div className='bg-success text-white rounded-pill text-center'>Active</div> : <div className='bg-warning text-white rounded-pill text-center'>inactive</div>}</td>
                                                    <td>{<Moment format="DD/MMMM/YYYY hh:mm:ss">{bnr.last_modify}</Moment>}</td>
                                                    <td>
                                                        <DropdownButton id="dropdown-basic-button" title="Action">
                                                            <Dropdown.Item><Link to={"/admin/banner/edit/" + bnr.sno}>Edit</Link></Dropdown.Item>
                                                            <Dropdown.Item onClick={() => Delete_bnr(bnr.sno)} id={bnr.sno}>Delete</Dropdown.Item>
                                                        </DropdownButton>
                                                    </td>
                                                </tr>
                                            </>)
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <>
                <Modal
                    size="lg"
                    show={lgShow}
                    onHide={() => setLgShow(false)}
                    aria-labelledby="example-modal-sizes-title-lg" id="pop"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-lg">
                            Add Banner
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card-body">
                                    <div className="table-responsive pt-3 px-3">
                                        <Form onSubmit={AddBanner} method="POST" enctype="multipart/form-data">
                                            <Form.Group className="mb-3" controlId="bannerimg">
                                                <MDBFile label='Image *' id='bannerimg' accept="image/*" />
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="status">
                                                <Form.Label htmlFor="page">Page Title *</Form.Label>
                                                <Form.Select id="page">
                                                    <option>Select Page</option>
                                                    {
                                                        menulist.map((menu) => {
                                                            return (<option>{menu.name}</option>)
                                                        })
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="Headding">
                                                <Form.Label>Headding</Form.Label>
                                                <Form.Control type="text" id="head" placeholder="Headding" />
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="Content">
                                                <Form.Label>Content</Form.Label>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data=""
                                                    onChange={(event, editor) => {
                                                        setcontent(editor.getData());
                                                    }}
                                                />
                                                <Form.Group className="mb-3" controlId="status">
                                                    <Form.Label htmlFor="status">Status</Form.Label>
                                                    <Form.Select id="status">
                                                        <option value={0}>Inactive</option>
                                                        <option value={1}>Active</option>
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group className="mt-3" controlId="description">
                                                    <input type="submit" className="btn btn-success" value='Banner Add' />
                                                </Form.Group>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        </div>
    </>)
}
export default Banner;